import { Constant, Headers } from "../apiConstants";

const GetBestOffer = async (
  outletID,
  originalAmt
) => {
  const endpoint = Constant.GET_BEST_OFFER;
  const BaseUrl = Constant.BASE_URL;
  try {
    const response = await fetch(BaseUrl + "/" + endpoint, {
      method: "post",
      headers: Headers,
      body: JSON.stringify({
        outletId: outletID,
        originalAmt: originalAmt
      }),
    });
    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export default GetBestOffer;
